import React, { useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const GoogleReview = () => {
    const navigate = useNavigate();
    const userSession = sessionStorage.getItem('user');
    const sesinstituteId = userSession ? JSON.parse(userSession).primaryInstitute : 0;
    // Parse the locally-stored institute settings once instead of re-reading/parsing it
    // repeatedly.
    const schoolSettingsRaw = localStorage.getItem('school_settings');
    const schoolSettings = schoolSettingsRaw ? JSON.parse(schoolSettingsRaw) : null;
    const instName = schoolSettings ? schoolSettings.name : '';
    const instPrimaryId = schoolSettings ? schoolSettings.id : '';
    // The Google review link is already part of the locally-stored institute settings
    // (same field the institute admin edits and that get-google-link returns), so we can
    // use it directly and skip an extra network round-trip during the redirect.
    const localGoogleLink = schoolSettings ? schoolSettings.googleLink : '';
    const jwtToken = localStorage.getItem('user-jwt-token');
    let googleLink = '';
    useEffect(() => { 

        
            const saveTemplate = async (schoolLogo: string): Promise<number | null> => {
                if (localGoogleLink) {
                    // Fast path: use the link already available locally, no network call needed.
                    googleLink = localGoogleLink;
                } else {
                    // Fallback: keep the original behaviour when the link isn't in local settings.
                    try {
                        const response = await axios.post(`${process.env.REACT_APP_BROADCAST_SERVER}/pre-signup/get-google-link`, {
                            id: instPrimaryId
                        });
                        if (response.data.success) {
                            googleLink = response.data.result; // Store the Google link in the variable
                        }
                    } catch (error) {
                        console.error('Error fetching file URL:', error);
                    }
                }
            const currentDate = new Date();
            const dateOptions: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            const formattedDate = currentDate.toLocaleDateString(undefined, dateOptions);
            const timeOptions: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
            const formattedTime = currentDate.toLocaleTimeString(undefined, timeOptions);
            const date = `${formattedDate} ${formattedTime}`;
       
            const body =`<p><strong>Dear @First_Name @Last_Name,</strong></p><p>I hope this message finds you well! As a cherished member of our alumni community, your journey and achievements are a testament to the quality of education and experiences at ${instName}. We are reaching out to ask for your help in sharing your story with others. </p><p>Would you be willing to post a review about your time at ${instName}  on Google. Your insights and experiences can inspire prospective students and their families, and help them make informed decisions about their education.</p><p>Your honest feedback is invaluable to us and to those considering joining our community.</p><p>Thank you for your continued support and for helping us spread the word about ${instName} </p><p><a href="${googleLink}" rel="noopener noreferrer" target="_blank" style="color: rgb(255, 255, 255); background-color: rgb(92, 177, 72);">Review Us on Google</a></p><p>Warm regards,</p><p><strong>Alumni Helpdesk</strong></p>`;
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_BROADCAST_SERVER}/email/save-template`,
                    {
                        subject: " Your review is precious to us!",
                        message: body,
                        school_ref_id: sesinstituteId,
                        status: 0,
                        created_date: date,
                        sender_mail: "Write your institute's review",
                        university_logo: schoolLogo || '',
                        template_ref_id:4,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${jwtToken}`,
                        },
                    }
                );

                return response.data.insertedId ?? null;
            } catch (error) {
                console.error('Error saving template:', error);
                return null;
            }
        };

        // Optimistic redirect: the alumni list only needs template_id when the user clicks
        // "Next", so navigate immediately and create the template in the background. Expose
        // the pending save (promise + sessionStorage + URL) so the "Next" action can pick up
        // the template_id even if it lands before the save finishes.
        const schoolLogoFromSession = sessionStorage.getItem('school-image') || '';
        sessionStorage.removeItem('google_review_template_id');
        const savePromise = saveTemplate(schoolLogoFromSession);
        (window as any).__googleReviewTemplatePromise = savePromise;
        savePromise.then((insertedId) => {
            if (insertedId) {
                sessionStorage.setItem('google_review_template_id', String(insertedId));
                const url = new URL(window.location.href);
                if (!url.searchParams.get('template_id')) {
                    url.searchParams.set('template_id', String(insertedId));
                    window.history.replaceState({}, '', url.toString());
                }
            } else {
                console.error('Inserted ID not found in the response');
            }
        });
        navigate(`/broadcast/alumni-profiles?type=5`);
    }, [sesinstituteId, jwtToken, navigate]);

    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading…</span>
            </div>
            <div className="mt-3">Preparing your Google review broadcast…</div>
        </div>
    );
};

export default GoogleReview;
